import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { ShieldAlert, Loader2 } from "lucide-react";
import { toast } from "sonner";

export function ConsentGate() {
    const { user } = useAuth();
    const [status, setStatus] = useState(null);
    const [busy, setBusy] = useState(false);
    const [dismissed, setDismissed] = useState(false);

    useEffect(() => {
        if (!user || user.role !== "customer") { setStatus(null); return; }
        api.get("/legal/consent-status").then((r) => setStatus(r.data)).catch(() => setStatus(null));
    }, [user]);

    // Only prompt returning customers whose accepted version is now outdated.
    const needs = status && !status.accepted && status.last_accepted_version && status.last_accepted_version !== status.current_version;
    if (!needs || dismissed) return null;

    const accept = async () => {
        setBusy(true);
        try {
            await api.post("/legal/accept", { context: "reconsent", version: status.current_version });
            setDismissed(true);
        } catch {
            toast.error("Could not record your acceptance. Please try again.");
        } finally { setBusy(false); }
    };

    return (
        <div className="fixed inset-0 z-[90] flex items-end justify-center bg-navy/50 p-4 sm:items-center" data-testid="reconsent-modal">
            <div className="w-full max-w-md rounded-2xl bg-white p-6 shadow-2xl">
                <div className="mb-3 flex items-center gap-2">
                    <div className="rounded-xl bg-orange/10 p-2.5"><ShieldAlert size={20} className="text-orange" /></div>
                    <h2 className="font-heading text-lg font-extrabold text-navy">Our policies have been updated</h2>
                </div>
                <p className="text-sm text-navy/60">
                    HOMIIE updated its policies to version <b>{status.current_version}</b>. Please review and accept to continue booking services.
                </p>
                <Link to="/legal" target="_blank" data-testid="reconsent-review-link" className="mt-3 inline-block text-sm font-bold text-orange">Review updated policies →</Link>
                <button
                    data-testid="reconsent-accept-btn"
                    disabled={busy}
                    onClick={accept}
                    className="mt-5 flex w-full items-center justify-center gap-2 rounded-full bg-orange py-3.5 text-sm font-bold text-white shadow-lg shadow-orange/30 active:scale-95 disabled:opacity-60"
                >
                    {busy && <Loader2 className="h-4 w-4 animate-spin" />} I AGREE &amp; CONTINUE
                </button>
            </div>
        </div>
    );
}
